import gql from 'graphql-tag'

export default gql`
mutation UpdateAutomationTask($id: ID!, $fields: ShopTaskUpdateInput!) {
  cashAssist {
    updateAutomationTask(id: $id, fields: $fields) {
      id
      name
    }
  }
}`
